import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanViewNotes = (): boolean => {
  const [canViewNotes, setCanViewNotes] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const viewPermissionAll: Permission = {
    resource: 'notes',
    action: 'readbasic',
    scope: 'all',
  };
  const viewPermissionSelf: Permission = {
    resource: 'notes',
    action: 'readbasic',
    scope: 'self',
  };

  const canViewAll = useHasPermission(user, viewPermissionAll);
  const canViewSelf = useHasPermission(user, viewPermissionSelf);

  React.useEffect(() => {
    setCanViewNotes(canViewAll || canViewSelf);
  }, [canViewAll, canViewSelf]);

  return canViewNotes;
};
